import React, { useState } from "react";
import images from "../../../Utils/importImages";
import TextField from "../Components/Inputs/TextField";

function PasswordDetailEdit({ passwordDetails, onClickCancel, onClickSave }) {
  let [PasswordDetail, setPasswordDetail] = useState(passwordDetails);

  let [oldPaswordError, setOldPaswordError] = useState("");
  let [newPasswordError, setNewPasswordError] = useState("");
  let [confirmNewPasswordError, setconfirmNewPasswordError] = useState("");

  let [oldPasword, setOldPasword] = useState("");
  let [newPassword, setNewPassword] = useState("");
  let [confirmNewPassword, setconfirmNewPassword] = useState("");

  // create validations of input

  console.log("PasswordDetail her eis : ", PasswordDetail);
  //   console.log("generalDetails her eis : ", generalDetails);

  let onChangeOldPassword = (e) => {
    setOldPaswordError("");
    setOldPasword(e.target.value);
  };

  let onChangeNewPassword = (e) => {
    setNewPasswordError("");
    setNewPassword(e.target.value);
  };

  let onChangeConfirmNewPassword = (e) => {
    setconfirmNewPasswordError("");
    setconfirmNewPassword(e.target.value);
  };

  let checkValidations = () => {
    let isValid = true;

    // Reset previous errors
    setOldPaswordError("");
    setNewPasswordError("");
    setconfirmNewPasswordError("");

    // Check if fields are empty
    if (!oldPasword) {
      setOldPaswordError("*Required");
      isValid = false;
    }
    if (!newPassword) {
      setNewPasswordError("*Required");
      isValid = false;
    }
    if (!confirmNewPassword) {
      setconfirmNewPasswordError("*Required");
      isValid = false;
    }

    if (!isValid) return false;

    // Validate old password
    if (oldPasword !== PasswordDetail.password) {
      setOldPaswordError("Invalid Old Password");
      return false;
    }

    // Validate new password strength (minimum 6 characters, at least 1 uppercase, 1 lowercase, 1 number, 1 special character)
    let passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;

    if (!passwordRegex.test(newPassword)) {
      setNewPasswordError(
        "Password must be at least 6 characters long, contain an uppercase letter, a lowercase letter, a number, and a special character"
      );
      return false;
    }

    if (oldPasword == newPassword) {
      setNewPasswordError(
        "New Password Can't be same as old password"
      );
      return false;
    }

    // Validate confirm password matches new password
    if (newPassword !== confirmNewPassword) {
      setconfirmNewPasswordError("Passwords do not match");
      return false;
    }

    return true; // All validations passed
  };

  let saveTheData = () => {
    // apply validations here and chekc them in the end do below

    let isAllValid = checkValidations();

    if (isAllValid == true) {
      console.log("PasswordDetail is : ", PasswordDetail);

      onClickSave(newPassword);
    }
  };

  return (
    <div className="userdb-content-right-internal-top">
      <div className="internal-tab-head">
        <h3>Password</h3>
        <div className="editable-profile-action">
          <ul class="userdb-cta-buttons">
            <li class="userdb-cancel-btn" onClick={() => onClickCancel(false)}>
              Cancel
            </li>
            <li class="userdb-save-btn" onClick={() => saveTheData()}>
              Save
            </li>
          </ul>
        </div>
      </div>
      <ul className="myprofile-general-details">
        <li>
          <label for="">Old Password</label>
          <TextField
            error={oldPaswordError}
            placeholder={"Enter Old Password"}
            focus={true}
            onChange={onChangeOldPassword}
            name="oldpassword"
            value={oldPasword}
          />
        </li>
        <li>
          <label for="">New Password</label>
          <TextField
            error={newPasswordError}
            placeholder={"Enter New Password"}
            focus={false}
            onChange={onChangeNewPassword}
            name="newpassword"
            value={newPassword}
          />
        </li>
        <li>
          <label for="">Confirm New Password</label>
          <TextField
            error={confirmNewPasswordError}
            placeholder={"Confirm New Password"}
            focus={false}
            onChange={onChangeConfirmNewPassword}
            name="newpassword"
            value={confirmNewPassword}
          />
        </li>
      </ul>
    </div>
  );
}

export default PasswordDetailEdit;
